import { Button as ChakraButton } from '@chakra-ui/react';
import { GetIcon } from '../../../components/icons';
import { IconMap } from '../../../components/icons/Icon.map';
import type { IconMapProps, IconSize } from '../../../components/icons/types';

export interface IconButtonProps {
    id: string;
    iconName: keyof typeof IconMap;
    isDisabled?: boolean;
    isLoading?: boolean;
    onClick?: (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    size?: IconSize;
    ariaLabel?: string;
}
export const IconButton = ({
    id,
    iconName,
    isDisabled = false,
    isLoading = false,
    onClick,
    size = 'md',
    ariaLabel,
}: IconButtonProps): React.ReactElement => {
    const iconProps: IconMapProps = IconMap[iconName] as IconMapProps;
    const { _hover, width, padding, backgroundColor } = iconProps[size];
    const widthValue = parseInt(width!, 10);
    const paddingValues = (padding || '0').split(' ');
    const secondPaddingValue =
        paddingValues.length === 2
            ? parseInt(paddingValues[1], 10)
            : parseInt(paddingValues[0], 10);
    const buttonSize = `${widthValue + secondPaddingValue * 2}px`;

    return (
        <ChakraButton
            data-testid={id}
            variant="icon-button"
            isDisabled={isDisabled}
            isLoading={isLoading}
            w={buttonSize}
            h={buttonSize}
            backgroundColor={backgroundColor}
            _hover={_hover}
            _disabled={{ opacity: 0.5 }}
            onClick={(evt) => onClick && onClick(evt)}
            aria-label={ariaLabel}
        >
            <GetIcon id={`${id}-icon-button`} name={iconName} size={size} disableHover />
        </ChakraButton>
    );
};

IconButton.defaultProps = {
    isDisabled: false,
    isLoading: false,
    size: 'md',
    onClick: undefined,
};
